import React, { useContext } from 'react';
import { CustomerContext } from '../../../contexts/CustomerContext';
import { useStudent } from '../_landing/Yearbooks';
import { usePanoramaPackage } from '../_landing/Panorama';
import PanoramaForm from '../_landing/Panorama/PanoramaForm';
import landingPageImg from '../../../assets/panorama-landing-page.jpg';
import Image from '../../Image';

const Panoramas = ({ afterAdd }) => {
  const { customer } = useContext(CustomerContext);
  const { student } = useStudent({ schoolId: customer.currentSchool.id, studentId: customer.currentStudent.studentId });
  const { yearbook, yearbooks } = usePanoramaPackage(customer.currentSchool.id);

  if (!student) return null;
  if (!yearbook) return null;

  return (
    <>
      <Image src={landingPageImg} alt="Purchase Panorama Image" />
      <PanoramaForm
        student={student}
        school={student.school}
        defaultYearbook={yearbook}
        yearbooks={yearbooks}
        pushToNextRoute={false}
        afterAdd={afterAdd}
        buttonText="Add to Cart"
      />
    </>
  );
};

export default Panoramas;
